<template>
  <div id="body">
    <div id="payment-form">
      <div id="payment-element"></div>
      <button id="submit" @click="pay">
        <div class="spinner" id="spinner" v-if="loading"></div>
        <span
          id="button-text"
          style="font-size: 1.2em; font-weight: 500"
          v-else
          >{{ `${$func.parseIso("subscriberWithCard")}` }}</span
        >
      </button>
      <div id="payment-message" v-if="errorMessage">{{ errorMessage }}</div>
      <div id="payment-element-express"></div>
    </div>
  </div>
</template>

<script>
const stripe = Stripe(process.env.VUE_APP_KEY_STRIPE, {
  locale: "en",
});

export default {
  data() {
    return {
      elements: null,
      loading: false,
      errorMessage: null,
    };
  },
  props: ["clientSecret", "price"],
  mounted() {
    const appearance = {
      theme: "stripe",
    };
    const options = {
      hidePostalCode: true,
      iconStyle: "solid",
      disableLink: true,
    };
    const elements = stripe.elements({
      clientSecret: this.clientSecret,
      appearance,
    });
    const paymentElement = elements.create("card", options);
    paymentElement.mount("#payment-element");
    this.elements = elements;

    const optionsExpress = {
      paymentMethods: {
        amazonPay: "never",
        googlePay: "always",
        link: "never",
        applePay: "always",
      },
      buttonType: {
        applePay: "subscribe",
        googlePay: "subscribe",
      },
      layout: {
        maxRows: 2,
      },
      buttonHeight: 40,
      buttonTheme: {
        applePay: "white-outline",
        googlePay: "white",
      }
    };
    const elementsExpress = stripe.elements({
      clientSecret: this.clientSecret,
      appearance,
    });
    const paymentElementExpress = elementsExpress.create(
      "expressCheckout",
      optionsExpress
    );
    paymentElementExpress.mount("#payment-element-express");
  },
  methods: {
    async pay() {
      try {
        this.loading = true;
        this.errorMessage = null;
        const result = await stripe.confirmCardPayment(this.clientSecret, {
          payment_method: {
            card: this.elements.getElement("card"),
            // billing_details: {
            //   name: "Jenny Rosen",
            // },
          },

          // clientSecret: this.clientSecret,
          // redirect: "if_required",
          // confirmParams: {
          //   return_url: `http://locahost:8081/pay-ok`,
          // },
        });

        console.log("result", result);
        const { error } = result;
        this.loading = false;
        console.log("error stripe", error);
        if (error) {
          this.errorMessage = error?.message || "An unexpected error occurred.";
        } else {
          this.errorMessage = this.$func.parseIso("successfulPayment");
          this.confirm();
        }
        //   this.$modal.hide("pay");
      } catch (error) {
        console.log(error);
        this.errorMessage = "An unexpected error occurred.";
      }
    },

    async confirm() {
      try {
        await this.$axios.get(
          `/payment/confirm/payment-intent?numberRef=${this.numberRef}`
        );
        this.$bus.emit("confirm-pay");
        this.$modal.hide("pay");
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
/* Variables */
* {
  box-sizing: border-box;
}

#body {
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 16px;
  -webkit-font-smoothing: antialiased;
  display: flex;
  justify-content: center;
  align-content: center;
  /* height: 100vh;
  width: 100vw; */
}

#payment-form {
  /* position: absolute;
  top: 20%; */
}

#payment-form {
  /* width: 30vw;
  min-width: 500px;
  align-self: center;
  box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),
    0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);
  border-radius: 7px;
  padding: 40px; */
}

.hidden {
  display: none;
}

#payment-message {
  color: rgb(105, 115, 134);
  font-size: 16px;
  line-height: 20px;
  padding-top: 12px;
  text-align: center;
}

#payment-element {
  margin-bottom: 24px;
}

/* Buttons and links */
button {
  background: #5469d4;
  font-family: Arial, sans-serif;
  color: #ffffff;
  border-radius: 4px;
  border: 0;
  padding: 12px 16px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: block;
  transition: all 0.2s ease;
  box-shadow: 0px 4px 5.5px 0px rgba(0, 0, 0, 0.07);
  width: 100%;
}
button:hover {
  filter: contrast(115%);
}
button:disabled {
  opacity: 0.5;
  cursor: default;
}

/* spinner/processing state, errors */
.spinner,
.spinner:before,
.spinner:after {
  border-radius: 50%;
}
.spinner {
  color: #ffffff;
  font-size: 22px;
  text-indent: -99999px;
  margin: 0px auto;
  position: relative;
  width: 20px;
  height: 20px;
  box-shadow: inset 0 0 0 2px;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
.spinner:before,
.spinner:after {
  position: absolute;
  content: "";
}
.spinner:before {
  width: 10.4px;
  height: 20.4px;
  background: #000000;
  border-radius: 20.4px 0 0 20.4px;
  top: -0.2px;
  left: -0.2px;
  -webkit-transform-origin: 10.4px 10.2px;
  transform-origin: 10.4px 10.2px;
  -webkit-animation: loading 2s infinite ease 1.5s;
  animation: loading 2s infinite ease 1.5s;
}
.spinner:after {
  width: 10.4px;
  height: 10.2px;
  background: #000000;
  border-radius: 0 10.2px 10.2px 0;
  top: -0.1px;
  left: 10.2px;
  -webkit-transform-origin: 0px 10.2px;
  transform-origin: 0px 10.2px;
  -webkit-animation: loading 2s infinite ease;
  animation: loading 2s infinite ease;
}

@-webkit-keyframes loading {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes loading {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@media only screen and (max-width: 600px) {
  form {
    width: 80vw;
    min-width: initial;
  }
}

#submit {
  margin-bottom: 9px;
  background-color: black;
  text-align: center;
  max-height: 40px;
}
</style>
